export function ListReasons() {
  const REASONS = document.querySelectorAll('.a-list--reasons li')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('show')
        console.log('ok')
        observer.unobserve(entry.target)
      }
    })
  })

  REASONS.forEach((el) => observer.observe(el))
}
